<template>
    <div class="container">
        <div class="card" id="patient-id">
            <div class="card-header">
                <div class="title-card">Kartu Pasien</div>
                <div class="izd-logo">
                    <img src="/img/card_pasien_logo.png" alt="izidok logo" />
                </div>
            </div>
            <div class="card-body">
                <div class="card-img-body">
                    <img v-if="klinik.foto_klinik == null" src="/img/card_pasien_body.jpg" alt="image body" />
                    <img v-else :src="klinik.foto_klinik" class="object-fit-cover" alt="image body" />
                </div>
                <div v-if="pasien.klinik" class="profile">
                    <h3 class="patient-name">{{ pasien.nama || "Default" }}</h3>
                    <h4 class="patient-number">
                        {{ pasien.nomor_rekam_medis || "7948625986294294" }}
                    </h4>
                    <h4 class="patient-dob mb-10">
                        {{ pasien.tanggal_lahir || "04 / 04 / 94" }}
                    </h4>
                    <div class="stright-row"></div>
                    <div class="clinic-desc">
                        <div class="clinic-icon">
                            <img src="/img/klinik_blue.png" alt="klinik" />
                        </div>
                        <div class="clinic-contact">
                            <h3 class="clinic-name">
                                {{
                                    pasien.klinik.nama_klinik || "Klinik Desire"
                                }}
                            </h3>
                            <p class="address">
                                {{
                                    pasien.klinik.alamat ||
                                    "Jl. wahyu Raya No. 22 Gandaria Selatan"
                                }}<br />
                                {{
                                    pasien.klinik.kota_detail.nama ||
                                    "Cilandak Jakarta Selatan"
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <div class="text-right">
                    <button
                        type="button"
                        class="btn btn-light cancel"
                        @click="$router.push('/pasien-klinik')"
                    >
                        Batal
                    </button>
                    <button
                        @click="printCard()"
                        type="button"
                        class="btn btn-primary ml-3 print"
                    >
                        Cetak
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            pasien: {},
        };
    },
    created() {
        this.getCardData();
    },
    computed: {
        klinik() {
            let kklinik =  this.$store.state.klinikUser.filter((item) => {
                return (item.pivot.klinik_id === this.$store.state.klinikId)
            });

            return kklinik[0];
        }
    },
    methods: {
        async getCardData() {
            let res = await this.$axios.get(
                `pasien-card/${this.$route.params.id}?klinik_id=${this.$route.query.klinik_id}`
            );
            this.pasien = res.data.data;
            this.pasien.tanggal_lahir = moment(
                this.pasien.tanggal_lahir
            ).format("DD / MM / YY");
        },
        async printCard() {
            let selectedKlinikId = this.klinik.id;

            let res = await this.$axios.post(
                `pasien-card/export/${this.$route.params.id}?klinik_id=${this.$route.query.klinik_id}`,
                {selectedKlinikId: selectedKlinikId},
                { responseType: "blob" }
            );
            const url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${this.pasien.nama}-${this.pasien.nomor_rekam_medis}.pdf`);
            document.body.appendChild(link);
            link.click();
        },
    },
};
</script>

<style scoped>
.container {
    width: 530px;
    padding-right: 20px;
    padding-left: 20px;
    margin-top: 100px;
    margin-right: auto;
    margin-left: auto;
}

.card {
    position: relative;
    display: -moz-box;
    display: flex;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 0 solid rgba(122, 123, 151, 0.3);
    border-radius: 0.65rem;
}

.card {
    box-shadow: 0 0.46875rem 2.1875rem rgb(0 0 0 / 3%),
        0 0.9375rem 1.40625rem rgb(0 0 0 / 3%),
        0 0.25rem 0.53125rem rgb(0 0 0 / 5%),
        0 0.125rem 0.1875rem rgb(0 0 0 / 3%);
}

.card-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 30px !important;
    background: rgb(159, 225, 255);
    background: linear-gradient(
        90deg,
        rgb(134, 217, 255) 0%,
        rgba(64, 177, 219, 1) 54%,
        rgba(7, 156, 226, 1) 100%
    );
}

.title-card {
    align-self: center;
    color: #ffffff;
    font-weight: 600;
    font-size: 1.2em;
    margin-top: 20px;
}

.izd-logo img {
    height: 45px;
}

.card-body {
    display: flex;
}

.card-img-body {
    width: 140px;
}

.card-img-body img {
    height: 200px;
    width: inherit;
    border-radius: 10px;
}

.object-fit-cover {
    object-fit: cover;
}

.profile {
    width: 300px;
    margin-left: 15px;
}

.patient-name {
    font-weight: 800;
    font-size: 1.3em;
}

.patient-number,
.patient-dob {
    font-size: 1em;
    margin: 10px 0;
}


.mb-10 {
    margin-bottom: 10px;
}

.clinic-desc {
    display: flex;
    width: 280px;
    margin-top: 15px;
}

.clinic-icon {
    background-color: #e4f2ff;
    height: 30px;
    border-radius: 50%;
}

.clinic-icon img {
    padding: 8px;
    height: 30px;
}

.stright-row {
    background-color: #cdcdcd;
    border: 0.8px solid #cdcdcd;
}

.clinic-contact {
    margin-left: 15px;
}

.clinic-name {
    font-weight: 600;
    font-size: 1em;
}

.address, .cp-klinik {
  width: 250px;
}

.address,
.telephone,
.email {
    color: #8ea3c3;
    font-weight: 400;
    font-size: 0.7em;
}

.email {
    padding-left: 20px;
}

.print {
    border-radius: 20px;
    font-weight: 500;
    background-color: #2636fa;
    border: 0;
}

.cancel {
    border-radius: 20px;
    background-color: #ffffff;
    border: 0;
    font-weight: 500;
}
</style>